import { useState, useContext, useEffect } from 'react'
import Consulta from './Types/consulta'
import Cadastro from './Types/cadastro'
import TabNavigation from '../General/TabNavigation'

const Fornecedores = () => {
    const [activeTab, setActiveTab] = useState('consulta')

    const tabs = [
        {
            key: 'consulta',
            label: 'Consulta',
            icon: 'folder',
            content: <Consulta />
        },
        {
            key: 'cadastro',
            label: 'Cadastro',
            icon: 'config',
            content: <Cadastro />
        }
    ]

    return (
        <div className='w-full min-h-full'>
            <TabNavigation
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                variant="default"
            />
        </div>
    )
}

export default Fornecedores
